import { useEffect, useState, useMemo, useCallback } from 'react';
import sessionState from '../SessionState';

export const useCreateContext = () => {
  const [state, _setState] = useState(sessionState);
  const setState = useCallback((stateName) => {
    _setState((p) => p.set(stateName).clone());
  }, []);

  const [cable, setCable] = useState(null);
  const [online, setOnline] = useState(false);

  const [messages, setMessages] = useState([]);
  const addMessage = useCallback(
    (message) => setMessages((p) => [...p, message]),
    [],
  );

  const [listeners, setListeners] = useState([]);
  const addListener = useCallback(
    (listener) => setListeners((p) => [...p, listener]),
    [],
  );
  const removeListener = useCallback(
    (listener) =>
      setListeners((p) =>
        p.filter((activeListener) => activeListener !== listener),
      ),
    [],
  );

  useEffect(() => {
    if (messages.length === 0) return;
    listeners.forEach((listener) => listener(messages.at(0)));
    setMessages((p) => p.slice(1));
  }, [messages, listeners]);

  const fullCable = useMemo(
    () => ({
      ...cable,
      online,
      useListener: createUseListener(addListener, removeListener),
    }),
    [cable, online, addListener, removeListener],
  );

  const [document, setDocument] = useState(null);

  const [session, setSession] = useState(null);
  const close = useCallback(() => setState('CLOSED'), [setState]);

  return useMemo(
    () => ({
      state,
      setState,

      cable: fullCable,
      setCable,
      setOnline,

      addMessage,

      document,
      setDocument,

      session,
      setSession,

      close,
    }),
    [
      close,
      state,
      setState,
      fullCable,
      addMessage,
      session,
      setSession,
      document,
    ],
  );
};

const createUseListener = (addListener, removeListener) => (listener) => {
  useEffect(() => {
    addListener(listener);
    return () => removeListener(listener);
  }, [listener]);
};
